// removed by extract-text-webpack-plugin
module.exports = {"floatingInputWrapper":"index__floatingInputWrapper___FhIbv","label":"index__label___1w-IA","required":"index__required___31FIg","toTop":"index__toTop___3zoFW","placeholder":"index__placeholder___16lbE","show":"index__show___2RyPg","default":"index__default___3SlSN","highlighted":"index__highlighted___3yaIG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/FloatLabelInput/index.less
// module id = 691
// module chunks = 3